import {UserModel} from './_models'

// Permission keys as seeded in the backend `permission` table. Keep in sync
// with fds-v2 `FdsPermissions.permission_dict` — the API enforces the same
// keys, so a UI gate on a key the backend doesn't check (or vice versa) shows
// controls that 403 when used.
export const LABOR_SCHEDULING_PERMS = {
  view: 'labor_scheduling.view',
  // Shift creation. Deleting/clearing shifts is modeled as `edit` on the
  // backend — there is no labor_scheduling.remove permission.
  create: 'labor_scheduling.create',
  edit: 'labor_scheduling.edit',
  editEmployees: 'labor_scheduling.edit_employees',
  approve: 'labor_scheduling.approve',
} as const

// Admin header-menu entries, mirroring the per-item gates of the fds-v2
// header (project/templates/v2/layout_pieces/header_menu.html).
export const ADMIN_MENU_PERMS = {
  users: 'users.view',
  hierarchy: 'hierarchy.view',
  commentary: 'commentary.view',
  hoursOfOperation: 'admin.view_hours_of_operation',
  calendarEvents: 'calendar_event.view',
} as const

// True when the user holds at least one of the given permission keys.
// FDS admins' profile permissions list contains every seeded key, so they
// pass these checks without special-casing.
export const hasPermission = (
  user: UserModel | undefined,
  ...permissions: string[]
): boolean => permissions.some((p) => user?.permissions?.includes(p) ?? false)

// Whether the user may modify schedules outside the normal editing window —
// past slots, weeks beyond the 4-week horizon, awaiting-approval/approved
// schedules. Replaces the legacy hardcoded Creator/Admin/DM role-name
// whitelist: schedule approvers are exactly the users trusted to change a
// locked schedule. (The create/edit permissions are still required for the
// mutation itself — this only lifts the time/status lock.)
export const canManageLockedSchedules = (user: UserModel | undefined): boolean =>
  hasPermission(user, LABOR_SCHEDULING_PERMS.approve)
